(function () {
  function getActiveMedia(section) {
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var media = section.querySelector(isDesktop ? '.video-section__media--desktop' : '.video-section__media--mobile');
    // Fall back to whichever variant actually exists, in case a
    // mobile video hasn't been uploaded (no --mobile element renders
    // at all) or a section only has one variant for some other
    // reason.
    return media || section.querySelector('.video-section__media');
  }

  function initVideo(section) {
    var media = getActiveMedia(section);
    if (!media) return;

    // Autoplay (muted) as soon as the video scrolls into view, instead
    // of requiring a click on the poster. Once loaded, the native
    // video controls (play/pause, volume/mute, fullscreen) take over —
    // the user can stop it, restart it, unmute it, or go fullscreen
    // from there.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (typeof media.loadContent === 'function') {
            // false = don't steal focus, since this is an automatic
            // scroll-triggered play, not a user click on the poster
            media.loadContent(false);
          }
          observer.unobserve(media);
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(media);
  }

  function init() {
    document.querySelectorAll('.video-section').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
